module.exports = __webpack_public_path__ + "static/media/metrotownMenu.ca793bb0.pdf";